

import styled from "styled-components";
import { Row, Col, Button, Container } from "react-bootstrap";
import { colors, types } from "../../../../../libs";
import { Modal } from "react-bootstrap";

export const TitleCellWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 700;
    img {
        border-radius: 0.5rem;
        border: 1px solid ${colors.background.darkGreen};
        height: 3.5rem;
        margin-right: 0.5rem;
    }
`
export const CustomButton = styled(Button)`
  background: ${colors.background.lightBlack};
  color: ${colors.text.white};
  padding: 8px 16px; 
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap; 
  &:hover {
 background: ${colors.background.lightGrey};
  }
`;
export const SaveButton = styled(Button)`
  margin-left: 8px;
`;
export const ThumbnailImage = styled.img`
  height: 75px;
  object-fit: cover;
  border-radius: 5px;
`;

export const ModalHeader = styled(Modal.Header)`
  background-color:${colors.background.lightBlack};
  color: ${colors.text.mediumWhite};
  border: none;
  padding: 15px 20px;
    color: ${colors.text.mediumWhite};
  border: none;
  padding: 15px 20px;
  position: sticky;
  top: 0;
  z-index: 10;
`;

export const OrderSelectionWrapper = styled.div`
  display: flex;
  height: calc(100vh - 50px);
  width: 100%;
`
export const LeftSection = styled.div`
 width: 50%;
  padding: 30px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  `;

export const RightSection = styled.div`
    width: 50%;
    padding: 30px;
    display: flex;
    justify-content: center;
    background-color: ${colors.background.lightBlack};
    align-items: center;
    gap: 10px; 
  `;
export const StyledContainer = styled(Container)`
  padding-top: 16px;
  max-width:1111px
`;

export const OrderSelectionRow = styled(Row)`
    .MuiTableHead-root {
        .MuiTableCell-root {
            border: none;
        }
    }
    .MuiTableBody-root{
        .MuiTableRow-root{
            &:nth-child(1){
                .MuiTableCell-root {
                    border-top: 1px solid ${colors.background.darkGreen};
                }
                .MuiTableCell-root:nth-child(1) {
                    border-top-left-radius: 0.5rem;
                }
                .MuiTableCell-root:nth-last-child(1) {
                    border-top-right-radius: 0.5rem;
                }
            }
            
            &:last-child {
                .MuiTableCell-root:nth-child(1) {
                    border-bottom-left-radius: 0.5rem;
                }
                .MuiTableCell-root:nth-last-child(1) {
                    border-bottom-right-radius: 0.5rem;
                }
            }
            .MuiTableCell-root {
                border-color: ${colors.background.darkGreen};
                
                &:nth-child(1){
                    border-left: 1px solid ${colors.background.darkGreen};
                }
                &:nth-last-child(1){
                    border-right: 1px solid ${colors.background.darkGreen};
                }
            }
        }
    }
`
export const OrderSelectionCol = styled(Col)``

export const NoResultsText = styled.p`
    color: ${colors.text.white};
    padding: 1rem;
`;
export const OrderSelectionHeader = styled.div`
    display: flex;
    justify-content: space-between;
`

export const OrderSelectionHeaderText = styled.h3`
    ${types.headers.itemMedium};
    color: ${colors.text.white};
    margin: 0.5rem 0;
`

export const OrderSelectionHeaderActions = styled.div`
    display: flex;
    gap: 1rem;
    align-items: center;
    justify-content: center;
`

export const PreviewWrapper = styled.div`
  height: 100%;
`;

export const PreviewHeader = styled.h5`
 ${types.body.normal};
 margin-top: 7px;
 color: ${colors.text.gray};
 font-weight:600 ;
 display: flex;
 justify-content: center;
`;

export const StyledNumberInput = styled.input<{ isValid: boolean }>`
  width: 40px;
  padding: 4px;
  text-align: center;
  font-size: 14px;
  border: ${({ isValid }) => (isValid ? '1px solid #ccc' : '1px solid red')};
  border-radius: 4px;
  appearance: textfield;
  -moz-appearance: textfield;

  /* Hide arrows for Chrome, Safari, Edge */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const ClickableIndex = styled.span`
  cursor: pointer;
`;


export const DashboardSearchWrapper = styled.div``;

export const SearchBarWrapper = styled.div`
  position: relative;
  width: 254px;
`;

export const SearchInput = styled.input`
  width: 100%;
  border-radius: 20px;
  padding: 8px 50px;
  background: ${colors.background.smokyBlack};;
  color: ${colors.text.white};
  border: 1px solid rgba(255, 255, 255, 0.2);

  &:focus {
    outline: none;
  }
`;

export const SearchIcon = styled.img`
  position: absolute;
  left: 25px;
  top: 14px;
  z-index: 1;
`;  
